export const COMMUNICATION_TYPES = [
  { key: 'CODE_SMS', value: 'Kod SMS' },
  { key: 'CODE_EMAIL', value: 'Kod e-mail' },
  { key: 'LINK_SMS', value: 'Link SMS' },
  { key: 'LINK_EMAIL', value: 'Link e-mail' },
];
